import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from "react-helmet-async";

const TESTIMONIAL_VIDEO_VIMEO_ID = '1168099694';

function Testimonials() {
  return (
    <>
    <Helmet>
        <title> Testimonials from our residents and families </title>
        <meta
          name="description"
          content="Hear from our residents and families about their experiences at Whitstable House."
        />
        <link rel="canonical" href="https://www.whitstable.house/testimonials"/>
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section testimonials-page">
          <div className="testimonials-container">
            <h1>Testimonials</h1>
          </div>
        </section>

        <section className="content-section testimonials-intro">
          <div className="section__container">
            <div className="section__text">
              <h2>Hear from our residents and families</h2>
              <p>At Whitstable House we are proud of the care we provide and the difference it makes to the lives of our residents and their families. Here you can watch and read about the experiences of those who have chosen to make Whitstable House their home.</p>
              <p>If you would like to find out more or arrange a visit, please <Link to="/contact-us" className="nurse-care-link">get in touch</Link>.</p>
            </div>
            <div className="section__image">
              <div className="nursing-video-wrapper">
                <iframe
                  src={`https://player.vimeo.com/video/${TESTIMONIAL_VIDEO_VIMEO_ID}?badge=0&autopause=0&player_id=0&app_id=58479`}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  title="Graham Care - January - Resident Testimonial"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Whitstable House <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
              <p>Copyright © Whitstable House</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default Testimonials;
